// ** Navigation sections imports

import routes from '../vertical/index.js'
// import dashboards from './dashboards'
// import misc from './misc'
// import brands from './brands'
// import supplier from './suppliers'
// ** Merge & Export
export default [...routes]
